import { render, staticRenderFns } from "./PositusWhatsapp.vue?vue&type=template&id=f0a4430e&"
import script from "./PositusWhatsapp.vue?vue&type=script&lang=js&"
export * from "./PositusWhatsapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports